import { createSlice } from "@reduxjs/toolkit";

const exploreSlice = createSlice({
  name: "explore",
  initialState: {
    showExploreSearch: false,
    lastSearch:null,
    tmdbExploreResult:null, //TMDB api results after Search
  },
  reducers:{
    toggleExploreSearchView: (state)=>{
        state.showExploreSearch =!state.showExploreSearch;
    },
    addLastSearch:(state, action)=>{
      state.lastSearch = action.payload;
    },

    addExploreMovieResult: (state,action)=>{
      const tmdbExploreResult = action.payload;
      state.tmdbExploreResult = tmdbExploreResult;
    },
    clearExploreList:(state)=>{
      state.tmdbExploreResult = null;
    }
  }
});

export const { toggleExploreSearchView, addExploreMovieResult, clearExploreList, addLastSearch } = exploreSlice.actions;
export default exploreSlice.reducer;